import { booleanAttribute, Component, computed, input, output, ViewEncapsulation } from "@angular/core";
import { VdsIconComponent } from "@dcc/vestas-design-system/angular/components/icon";
import { mapAppearanceToIcon } from "./map-appearance-icon.util";
import { VdsInlineAlertAppearance, VdsInlineAlertContrastType, VdsInlineAlertRole } from "./types";

@Component({
    selector: "vds-inline-alert",
    exportAs: "vdsInlineAlert",
    templateUrl: "./inline-alert.html",
    styleUrl: "./inline-alert.css",
    encapsulation: ViewEncapsulation.None,
    host: {
        class: "vds-inline-alert",
        "[class.vds-inline-alert--dismissible]": "dismissible()",
        "[class.vds-inline-alert--low-contrast]": "contrast() === 'low'",
        "[class.vds-inline-alert--high-contrast]": "contrast() === 'high'",
        "[class.vds-inline-alert--inline]": "inline()",
        "[class]": "'vds-inline-alert-' + appearance()",
        "[attr.role]": "role()"
    },
    imports: [VdsIconComponent]
})
export class VdsInlineAlert {
    readonly appearance = input<VdsInlineAlertAppearance>("neutral");

    readonly contrast = input<VdsInlineAlertContrastType>("medium");

    protected readonly alertIcon = computed(() => mapAppearanceToIcon(this.appearance(), this.contrast()));

    readonly dismissible = input(false, { transform: booleanAttribute });

    readonly dismissLabel = input<string>("Dismiss");

    readonly heading = input<string | null>(null);

    readonly message = input<string | null>(null);

    readonly inline = input(false, { transform: booleanAttribute });

    readonly role = input<VdsInlineAlertRole>("alert");

    readonly dismiss = output<void>();
}
